module.exports = __webpack_public_path__ + "img/Ed.d0ba0e02.png";